
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../../user.service';
import { PlycaDataService } from '../../../../services/plyca.service';
import { Configuration } from '../../../conf/app.constants';
import { UIService } from '../../../ui.service';
import { WaitLoadingService } from '../../../components/common/waitLoading/wait-loading.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { SessionInfo } from '../../../api/UserPrefs-dto';
import { JwtHttpInterceptor } from '../../../../http/jwt.http-interceptor';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { BaseComponent } from '../../../components/common/baseComponent/base.component';
import { DialogService } from 'primeng-lts/dynamicdialog';

@Component({
  selector: 'user-2fa-config',
  templateUrl: 'user-2fa-config.template.html',
  providers: [DialogService]
})
export class User2faConfigComponent extends BaseComponent implements OnInit, OnDestroy {

  public qrCodeUrl: string;
  public user2faCode: string;
  public errorMsg: string;

  @Output()
  public validCode = new EventEmitter<boolean>(false);


  constructor(private userService: UserService, private plycaService: PlycaDataService, private configuration: Configuration,
    private uiService: UIService, private confirmationService: ConfirmationService, private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService, private store: Store<AppState>, private jwtHttpInterceptor: JwtHttpInterceptor,
    private translateService: TranslateService, private _http: HttpClient) {
    super();

  }

  ngOnInit() {
    let headers = new HttpHeaders({ 'Accept': 'text/plain' });
    this.subscribe(
      this.plycaService.getAsText(this.configuration.URL_BASE + this.configuration.USERS_SERVICE_URL + 'passwords/qrcode', headers)
      , (qrCode: string) => {
        this.waitService.cancelWaiting();
        this.qrCodeUrl = qrCode;
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error);
      });
  }

  public validateQrCode(): void {
    this.subscribe(
      this.enable2faCode(true, this.user2faCode),
      () => {
        this.errorMsg = undefined;
        this.validCode.next(true);
        this.uiService.showSuccess(this.translateService.instant('TwoFactor.userprefs.activation_success'),
          this.translateService.instant('General.warn'));
      },
      (error: any) => {
        this.validCode.next(false);
        this.errorMsg = this.translateService.instant('TwoFactor.wrongCode');
        // this.plycaErrorHandler.showServerError(error);
      });
  }

  private enable2faCode(enable: boolean, user2faCode: string): Observable<SessionInfo> {
    this.waitService.startWaiting();
    let url = this.configuration.URL_BASE + this.configuration.USERS_SERVICE_URL + 'passwords/enable2fa';
    return this._http.put(url, {
      'enabled': enable,
      'verificationCode': user2faCode
    }, { observe: 'response' }).pipe(
      catchError((error: any) => {
        if (error.status === 403) {
          this.errorMsg = this.translateService.instant('TwoFactor.wrongCode');
          return throwError(this.translateService.instant('TwoFactor.wrongCode'));
        } else {
          return throwError(error);
        }
      }),
      switchMap(() => this.jwtHttpInterceptor.renewAuth(user2faCode)),
      finalize(() => this.waitService.cancelWaiting())
    );
  }

}
